"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var newInboxRuleOperation_1 = require("owa-service/lib/operation/newInboxRuleOperation");
var newInboxRuleRequest_1 = require("owa-service/lib/factory/newInboxRuleRequest");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Sends out the service request to update an inbox rule
 * @param newInboxRuleData the object that contains the new rule data
 * @return a promise that contains NewInboxRuleResponse
 */
function newInboxRuleService(newInboxRule) {
    var requestBody = newInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        InboxRule: newInboxRule,
    });
    return newInboxRuleOperation_1.default(requestBody);
}
exports.default = newInboxRuleService;
//# sourceMappingURL=newInboxRuleService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/newInboxRuleService.js
// module id = 5233
// module chunks = 2